import useTranslation from 'next-translate/useTranslation';

// Hooks
import {
    ADD_ALBUM_TYPE,
    REMOVE_ALBUM_TYPE,
    useAlbumContext
} from '@/utils/hooks/context/useAlbumContext';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

// Lib
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import RadioLabel from '@/components/composite/Radio/RadioLabel';
import Icon from '@/components/base/Icon';

const InstagramMediaType = () => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();
    const { activeSocialProfile } = useActiveSocialProfile();
    const network = activeSocialProfile?.social_network_type;
    const isStories = albumInfo?.criteria?.album_type === 'stories';

    if (network !== INSTAGRAM || albumInfo?.id) {
        return null;
    }

    return (
        <div className="border-b border-icoGray-300 p-5 dark:border-icoDarkMode-beton sm:p-8">
            <div className="mb-5 font-GBold text-icoBlack dark:text-white">
                {t('modal.label_instagram_type')}
            </div>
            <div className="space-y-3">
                <RadioLabel
                    variant="button"
                    onChange={() => {
                        dispatch({
                            type: REMOVE_ALBUM_TYPE
                        });
                    }}
                    checked={!isStories}>
                    <span className="flex items-center">
                        <Icon icon="content" className="mr-3 text-base text-icoBlue" />
                        {t('modal.instagram_type_posts')}
                    </span>
                </RadioLabel>
                <RadioLabel
                    variant="button"
                    onChange={() => {
                        dispatch({
                            type: ADD_ALBUM_TYPE,
                            payload: 'stories'
                        });
                    }}
                    checked={isStories}>
                    <span className="flex items-center">
                        <Icon icon="story" className="mr-3 text-base text-icoBlue" />
                        {t('modal.instagram_type_stories')}
                    </span>
                </RadioLabel>
            </div>
        </div>
    );
};

export default InstagramMediaType;
